import { ReactComponent as PencilIcon } from "../../../../assets/img/icons/pencil.svg";
import { useTranslation } from "react-i18next";

export default function EditItemButton({ onClick, className }) {
  const { t } = useTranslation();
  return (
    <button className={`${className} flex flex-row`} onClick={onClick}>
      <PencilIcon className="self-center w-6 h-6" />{" "}
      <span className="text-base self-center">{t("registrationsPage.actions.edit")}</span>
    </button>
  );
}
